import { getTranslate } from '@/utils/api-interceptors'

interface OutstandingFeatureProps {
  outstandingFeatures: {
    order: number
    value: {
      vi: string
      en: string
    }
  }[]
}

const OutstandingFeature = ({
  outstandingFeatures,
}: OutstandingFeatureProps) => {
  return (
    <>
      {outstandingFeatures && outstandingFeatures.length > 0 && (
        <div className='border-t-8 py-4 border-[#F3F4F6]'>
          <h2 className='text-base px-2 pb-2 font-bold'>Đặc điểm nổi bật</h2>
          <div className='ostf mt-2 pl-[14px] space-y-2 text-sm'>
            {outstandingFeatures?.map((item, index) => (
              <div className='mb-2 flex' key={index}>
                <span className='mt-2 flex h-[5px] max-w-[5px] flex-[5px] items-center justify-center rounded-full border border-dark-400 text-sm'></span>
                <span className='ml-3 flex-2 leading-6'>
                  {getTranslate(item.value)}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  )
}

export default OutstandingFeature
